import { JSX, PropsWithChildren } from 'react';
import classNames from 'classnames';
import classes from './ListItem.module.scss';

interface IProps {
    label: string | JSX.Element;
    onClick(): void;
    disabled?: boolean;
    className?: string;
    dataQa?: string;
}

export const ListItem = (props: PropsWithChildren<IProps>): JSX.Element => (
    <div
        className={classNames(classes.item, props.className, {
            [classes.disabled]: props.disabled,
        })}
        role="presentation"
        onClick={() => {
            if (!props.disabled) {
                props.onClick();
            }
        }}
        data-qa={props.dataQa}
    >
        {props.label}
        {props.children}
    </div>
);
